import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=32fdf5c0&scoped=true&"
import script from "./Pending.vue?vue&type=script&lang=js&"
export * from "./Pending.vue?vue&type=script&lang=js&"
import style0 from "./Pending.vue?vue&type=style&index=0&id=32fdf5c0&lang=scss&scoped=true&"
import style1 from "./Pending.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fdf5c0",
  null
  
)

export default component.exports